import styled from 'styled-components'

import { Box, Flex } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import { formatPhoneNumberWithoutCountryCode } from 'app/utils/phonenumber/helpers'

type Props = {
  agencyName: string
  brandingLogoURL: string
  contactEmail: string
  contactNumber: string
  managerFirstName: string
  managerLastName: string
}

const ContainerBox = styled(Box)`
  width: 232px;
  border-radius: 4px;
  background-color: #f9f9f9;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  margin-left: auto;
`

const StyledTrimmedLink = styled(Text).attrs({ as: 'a' })`
  max-width: 232px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const AgencyInfoBox = ({
  agencyName,
  brandingLogoURL,
  managerFirstName,
  managerLastName,
  contactEmail,
  contactNumber,
}: Props) => {
  const formatedContactNumber =
    contactNumber && formatPhoneNumberWithoutCountryCode(contactNumber)
  return (
    <Box className="col-sm-6" alignItems="right">
      <ContainerBox>
        <Flex
          flexDirection="column"
          p="24px 16px"
          alignItems="center"
          gridGap="16px"
        >
          {brandingLogoURL && (
            <img src={brandingLogoURL} alt="branding logo"></img>
          )}

          {!brandingLogoURL && (
            <Text as="span" fontSize={7} fontWeight="500" textAlign="center">
              {agencyName}
            </Text>
          )}

          <Flex flexDirection="column" gridGap="8px" width="100%">
            <Text as="span" fontSize={5} fontWeight="500">
              {managerFirstName} {managerLastName}
            </Text>

            {contactNumber && (
              <StyledTrimmedLink
                fontSize={4}
                fontWeight="400"
                href={`tel:${contactNumber}`}
              >
                {formatedContactNumber}
              </StyledTrimmedLink>
            )}

            {contactEmail && (
              <StyledTrimmedLink
                fontSize={4}
                fontWeight="400"
                href={`mailto:${contactEmail}`}
              >
                {contactEmail}
              </StyledTrimmedLink>
            )}
          </Flex>
        </Flex>
      </ContainerBox>
    </Box>
  )
}

export default AgencyInfoBox
